import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';

import { useCurrentAccountId } from '@zapier/checkout/src/hooks';
import { currentPlanTiersQuery as CurrentPlanTiersQuery } from './types/currentPlanTiersQuery';

const currentPlanTiersQuery = gql`
  query currentPlanTiersQuery($accountId: Int!) {
    account(id: $accountId) {
      id
      currentPlan: planV2 {
        tiers {
          numTasks
          pricePerTask
        }
      }
    }
  }
`;

type Props = {
  skip?: boolean;
};

export const useCurrentPlanTiers = ({ skip }: Props = {}) => {
  const { accountId } = useCurrentAccountId({ skip });

  const { data, error, loading } = useQuery<CurrentPlanTiersQuery>(
    currentPlanTiersQuery,
    {
      skip: skip || !accountId,
      variables: {
        accountId,
      },
    }
  );

  return {
    currentPlanTiers: data?.account?.currentPlan?.tiers ?? [],
    error: error ? 'Error loading plan tier information.' : undefined,
    isLoading: loading,
  };
};
